import { render, staticRenderFns } from "./ExpenseDetails.vue?vue&type=template&id=7237b6f0"
import script from "./ExpenseDetails.vue?vue&type=script&lang=js"
export * from "./ExpenseDetails.vue?vue&type=script&lang=js"
import style0 from "./ExpenseDetails.vue?vue&type=style&index=0&id=7237b6f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports